import * as React from "react";

import cn from "classnames";

import { DropdownContext, IndexedObject } from "./DropdownProvider";

export interface DropdownMenuItemProps {
    item?: IndexedObject;
    index?: number;
}

export const DropdownMenuItem = (props: React.PropsWithChildren<DropdownMenuItemProps>) => {
    const { item, index } = props;

    const { classes, itemProps, highlightedIndex } = React.useContext(DropdownContext);

    const selected = highlightedIndex === index;
    const className = cn(
        classes?.listItem,
        selected ? classes?.listItemSelected : null
    );

    return typeof index === "number" && item ? (
        <li
            className={className}
            {...itemProps[index]}
        >
            <span className={classes?.listItemText}>{item.label}</span>
        </li>
    ) : null;
};
